import React from 'react'
import { InputStyle } from './style'
import InputMasked from 'react-input-mask'
import { InputProps } from '../../types/components/input'

export const InputText: InputProps = ({
  useMask = false,
  layoutMask,
  label,
  onFocus,
  onBlur,
  onChange,
  value,
  disabled,
  placeholder,
  isValidate = true,
  widthDiv = '100%',
  handleKeyUp
}) => {
  return (
    <InputStyle isValidate={isValidate} widthDiv={widthDiv}>
      <label>{label}</label>
      {!useMask && (
        <input
          type="text"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onKeyUp={handleKeyUp}
        />
      )}
      {useMask && (
        <InputMasked
          type="text"
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          mask={layoutMask as string}
        />
      )}
    </InputStyle>
  )
}
